import React from 'react';
import { Link } from 'react-router-dom';
import { localizedPath } from './paths';

/**
 * Lien interne. Le routeur ajoute déjà tout seul le préfixe de la langue courante à un <Link> ordinaire :
 * en pratique on écrit donc <Link to="/panier"> comme avant. LocalizedLink sert dans les deux cas où
 * ce n'est pas suffisant :
 *   <LocalizedLink to="/faq" lang="de">…</LocalizedLink>   lien vers une AUTRE langue que la courante
 *                                                          (vrai lien <a href hreflang>, rechargement de page)
 *   sans `lang`                                             = <Link> ordinaire (langue courante)
 */
const LocalizedLink = React.forwardRef(({ to, lang, ...rest }, ref) => {
  // eslint-disable-next-line jsx-a11y/anchor-has-content -- le contenu arrive par `rest` (children)
  if (lang) return <a ref={ref} href={localizedPath(to, lang)} hrefLang={lang} lang={lang} {...rest} />;
  return <Link ref={ref} to={to} {...rest} />;
});
LocalizedLink.displayName = 'LocalizedLink';

export default LocalizedLink;
